import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function SettlementPaymentsDropdownMenu({
  anchorEl,
  open,
  onClose,
  onEdit,
  paymentId = "",
}) {
  return (
    <Menu
      id={`settlement-payments-row-menu-${paymentId}`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: SETTLEMENT_STYLES.menuPaper,
        },
      }}
    >
      <MenuItem id={`settlement-payments-row-menu-edit-${paymentId}`} onClick={onEdit}>
        <ListItemText primary="Edit" />
        <ListItemIcon sx={SETTLEMENT_STYLES.menuListItemIcon}>
          <Svg
            name={SvgEnum.HisEdit3}
            color={HNSColors.primary[500]}
            sx={SETTLEMENT_STYLES.menuEditIcon}
          />
        </ListItemIcon>
      </MenuItem>
    </Menu>
  );
}
